export default "__VITE_ASSET__eToLisKk__"